import Reflux from 'reflux';
import PermissionData from 'shared/data/Permission';

var async = { asyncResult: true },
  PermissionActions = Reflux.createActions({
    populateNames: async,
  });

PermissionActions.populateNames.listenAndPromise(PermissionData.getNames);

export default PermissionActions;
